// import React from "react";

// const Maintenance: React.FC = () => {
//   return (
//     <div
//       style={{
//         minHeight: "100vh",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         background: "linear-gradient(135deg, #020617, #0f172a)",
//         color: "#fff",
//         padding: "40px",
//       }}
//     >
//       <div
//         style={{
//           maxWidth: "520px",
//           width: "100%",
//           background: "rgba(255,255,255,0.06)",
//           borderRadius: "18px",
//           padding: "40px",
//           textAlign: "center",
//           boxShadow: "0 30px 60px rgba(0,0,0,0.5)",
//         }}
//       >
//         <div style={{ fontSize: "52px", marginBottom: "16px" }}>🛠️</div>

//         <h1 style={{ fontSize: "28px", marginBottom: "10px" }}>
//           System Under Maintenance
//         </h1>

//         <p style={{ opacity: 0.85, lineHeight: 1.6 }}>
//           We are currently updating the system or performing maintenance.
//           <br />
//           Please check back shortly.
//         </p>

//         <div style={{ marginTop: "28px", fontSize: "13px", opacity: 0.6 }}>
//           Thank you for your patience
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Maintenance;


import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthStore } from "../store/authStore";
import odooClient from "../services/odooClient";

const POLL_INTERVAL = 8000; // 8 seconds

const Maintenance: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuthStore();

  useEffect(() => {
    const backend =
      (odooClient as any)["backendURL"] ||
      process.env.REACT_APP_BACKEND_URL ||
      "";

    const checkMaintenance = async () => {
      try {
        const res = await fetch(`${backend}/api/admin/maintenance`, {
          credentials: "include",
        });
        const data = await res.json();

        // ✅ Maintenance OFF → leave screen
        if (!data?.maintenance) {
          if (isAuthenticated) {
            navigate("/dashboard", { replace: true });
          } else {
            navigate("/login", { replace: true });
          }
        }
      } catch {
        // ignore errors, stay on maintenance
      }
    };

    const timer = setInterval(checkMaintenance, POLL_INTERVAL);

    return () => clearInterval(timer);
  }, [isAuthenticated, navigate]);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, #020617, #0f172a)",
        color: "#fff",
        padding: "40px",
      }}
    >
      <div
        style={{
          maxWidth: "520px",
          width: "100%",
          background: "rgba(255,255,255,0.06)",
          borderRadius: "18px",
          padding: "40px",
          textAlign: "center",
          boxShadow: "0 30px 60px rgba(0,0,0,0.5)",
        }}
      >
        <div style={{ fontSize: "52px", marginBottom: "16px" }}>🛠️</div>

        <h1 style={{ fontSize: "28px", marginBottom: "10px" }}>
          System Under Maintenance
        </h1>

        <p style={{ opacity: 0.85, lineHeight: 1.6 }}>
          We are currently updating the system or performing maintenance.
          <br />
          This page will refresh automatically once the system is available.
        </p>

        <div style={{ marginTop: "28px", fontSize: "13px", opacity: 0.6 }}>
          Thank you for your patience
        </div>
      </div>
    </div>
  );
};

export default Maintenance;
